define(['basecollection'], (BaseCollection) => BaseCollection.extend({
    url: '/webanalytics/providers'
}));
